import React from 'react';
import { A } from 'hookrouter';

const DisplayItem = ({ item }) => {
    if (!item.link || !item.link.length) {
        return <div title={item.detailedName}>{item.name}</div>;
    }
    return (
        <A className='text-primary d-block' title={item.detailedName} href={item.link}>
            {item.name}
        </A>
    );
};

const DisplayItemList = ({ items }) => {
    return (
        <div>
            {items.map((item) => (
                <DisplayItem key={item.id} {...{ item }} />
            ))}
        </div>
    );
};

export default DisplayItemList;
